module.exports = __webpack_public_path__ + "media/playing_full_house_6.caf136ba.mp3";